import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/mapTo'
import * as App from '../../../app'
import * as Menu from '../../../components/menu'
import { ApplicationState } from '../../../rootReducer'
import * as Router from '../../../router'
import * as Actions from './actions'

const initialLoad = (
  action$: ReduxObservable.ActionsObservable<Router.OnEnterAction>,
  store: Redux.Store<ApplicationState>,
  { history }: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.CONTENT_IMPORTS_ERRORS_URL))
  .map((action: Router.OnEnterAction) =>
  Actions.fetchErrors(
      action.params.data_source_run_id,
    ))

export const epic = ReduxObservable.combineEpics(
  initialLoad,
)



// WEBPACK FOOTER //
// ./src/pages/imports/errors/epic.ts